import { styled } from "@mui/material";
import { StyledComponentProps } from "../../models/global/Types";

export const StyledForm = styled("form")(({ theme }: StyledComponentProps) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  ".row": {
    display: "flex",
    gap: "1rem",
    width: "100%",
    justifyContent: "space-between",
    ".column": {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      alignItems: "center",
      flex: "1",
      h4: {
        width: "100%",
      },
      ".MuiInputBase-root": {
        width: "100%",
        height: "3rem",
      },
      p: {
        color: theme.color.main,
      },
      ".imageWrapper": {
        width: "15rem",
        height: "15rem",
        border: `3px solid ${theme.color.main}`,
        borderRadius: "25px",
        overflow: "hidden",
        img: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
        },
      },
      "input[type='file']": {
        cursor: "pointer",
        position: "absolute",
        width: "30rem",
        height: "3rem",
        opacity: "0",
        border: "1px solid red",
      },
      ".fileInput": {
        position: "relative",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        width: "20rem",
        cursor: "pointer",
        height: "3rem",
        background: theme.contrast.lighter,
        borderRadius: "5px",
        paddingInline: "2rem",
        ".MuiInputBase-root": {
          width: "fit-content",
          height: "3rem",
        },
        ".input-label": {
          color: theme.color.dark,
          fontWeight: "bold",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0",
        },
        ".icon-wrapper": {
          background: theme.palette.primary.main,
          height: "100%",
          width: "5rem",
          display: "flex",
          alignItems: "center",

          justifyContent: "center",
        },
      },
    },
    ".MuiSelect-multiple": {
      minHeight: "3rem",
      padding: "0.5rem 1rem",
      borderRadius: "0.75rem",
      background: theme.contrast.lighter,
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "0.5rem",
    },

    ".MuiOutlinedInput-root": {
      borderRadius: "20px",
      background: theme.contrast.lighter,
      "& fieldset": {
        borderColor: theme.color.main,
      },
      "&:hover fieldset": {
        borderColor: theme.color.dark,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
}));
